let loading = {};
let loaded = {};

const requireScript = src => {
    return new Promise((resolve, reject) => {
        if (loaded[src]) return resolve();

        let returnAfter = typeof loading[src] !== "undefined";

        loading[src] = loading[src] || [];
        loading[src].push(resolve);

        if (returnAfter) return;

        var e = document.createElement("script");
        e.src = src;
        e.defer = true;
        e.type = "text/javascript";
        e.addEventListener("load", () => {
            loaded[src] = true;

            if (loading[src] instanceof Array) {
                loading[src].forEach(_resolve => _resolve());
            }
        });
        document.getElementsByTagName("head")[0].appendChild(e);
    });
};

export { requireScript };
